import styled from 'styled-components';
import { gridSizes } from 'utils/style';
import MRStops from 'components/form/MRStops/container';

export default styled(MRStops)`
  margin: ${gridSizes('L')} 0;

  .stop:last-of-type {
    margin-bottom: ${gridSizes('S')};
  }
  .collectionMainStop {
    margin-top: ${gridSizes('XL')};
  }

  .addShipment-disabled {
    color: var(--grey700);
    margin-top: ${gridSizes('M')};
    font-size: 14px;
    font-weight: 500;
    height: ${gridSizes('L')};
    display: flex;
    align-items: center;
  }
`;
